<template>
  <div @scroll="scrollHandler" @touchmove.prevent class="search-page" id="searchPage">
    <div class="search-bar">
      <form action="javascript:;">
        <input
          @change="searchTextChange"
          @keyup.enter="searchInfo(sortChecked, pageNum, true)"
          placeholder="搜索"
          ref="search"
          type="search"
          v-focus="true"
          v-model="searchText"
        />
      </form>
      <button @click="$emit('close')" class="cancel">取消</button>
    </div>
    <div class="search-page-wrapper">
      <div class="search-container">
        <div class="title" v-show="count > 0">
          <div class="title-wrapper">
            <p>
              共有
              <em>{{count}}</em>
              件符合“{{SearchFinishedTit}}”的商品
            </p>
            <button @click="sortProduct" class="price-sort">
              <span>价格</span>
              <div class="triangle">
                <a
                  :class="sortChecked === 1 ? 'checked' : '' "
                  class="up-triangle"
                  href="javascript:;"
                ></a>
                <a
                  :class="sortChecked === 2 ? 'checked' : '' "
                  class="down-triangle"
                  href="javascript:;"
                ></a>
              </div>
            </button>
          </div>
        </div>
        <div @touchmove.stop class="search-list" v-if="searchList.length">
          <load-more :finished="finished" @load="onLoad" finished-text="没有更多了" v-model="loading">
            <product-single :list="searchList"></product-single>
          </load-more>
        </div>
      </div>
      <div class="no-data" v-show="!searchList.length && noData">
        <p>没有找到包含“{{SearchFinishedTit}}”的商品</p>
      </div>
      <div class="search-default" v-show="!searchList.length && showRecords">
        <div class="search-records" v-show="recordList.length">
          <h2>搜索记录</h2>
          <ul class="list">
            <li :key="index" v-for="(item, index) in recordList">
              <button @click="searchRecord(item)">{{item}}</button>
            </li>
          </ul>
        </div>
        <div class="hot-recomment" v-show="showHot">
          <h2>热门推荐</h2>
          <ul class="list">
            <!-- <li v-for="(item, index) in records" :key="index">
              <button @click="searchRecord(item)">{{item}}</button>
            </li>-->
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { List } from 'vant'
import ProductSingle from './ProductSingle'
import { mapActions, mapState } from 'vuex'
let flag = false
export default {
  name: 'searchForProduct',
  components: {
    ProductSingle,
    LoadMore: List
  },
  directives: {
    focus: {
      inserted: (el) => {
        el.focus()
      }
    }
  },
  computed: {
    ...mapState('store', [
      'recordList'
    ])
  },
  data () {
    return {
      searchText: '',
      searchList: [],
      count: 0,
      SearchFinishedTit: '',
      sortChecked: 0, // '默认排序': 0 '价格由低到高': 1 '价格由高到低': 2
      noData: false,
      showRecords: true,
      showHot: false,
      loading: false,
      finished: false,
      pageNum: 1,
      scrollTop: 0,
      csid: []
    }
  },
  mounted () {
    if (sessionStorage.getItem('csid')) {
      this.csid = JSON.parse(sessionStorage.getItem('csid'))
    }
    if (this.$route.query.title) {
      window.document.title = this.$route.query.title + '-搜索'
    }
  },
  methods: {
    ...mapActions('store', [
      'getRecords'
    ]),
    /**
     * 分页加载
    */
    onLoad () {
      // 异步更新数据
      if (flag) {
        return false
      }
      flag = true
      setTimeout(() => {
        this.searchInfo(this.sortChecked, ++this.pageNum).then(() => {
          this.loading = false
          flag = false
        })
      }, 500)
    },
    searchTextChange () {
      this.pageNum = 1
      this.searchList = []
      window.scrollTo(0, 0)
    },
    /**
     * 搜索记录搜索
    */
    async searchRecord (title) {
      this.searchText = title
      this.pageNum = 1
      await this.searchInfo(this.sortChecked, this.pageNum, true)
      await this.getRecords(this.searchText)
    },

    /**
     * 获取搜索数据
     * @param{} sort 排序方式
     * @param{} pageNum 页码
     * @status{} status true为默认, false
    */
    async searchInfo (sort, pageNum, status) {
      if (this.searchText.trim() === '') {
        this.$toast('请输入商品名称或编号')
        return false
      }
      this.$refs.search.blur()
      if (status) {
        this.sortChecked = 0
      }
      const { cid } = this.$route.query
      const params = {
        title: this.searchText,
        page: pageNum
      }
      const res = await this.$axios.get(`/api/goods/channelItemsFirst/${cid}/${this.pageNum}/${sort}`, { params })
      if (res.status === 200) {
        this.SearchFinishedTit = this.searchText.replace(/(^\s*)|(\s*$)/g, '')
        this.getRecords(this.searchText)
        const { code, data, count, msg } = res.data
        if (code === 0) {
          this.count = count
          if (pageNum === 1) {
            this.searchList = data
            this.finished = false
            this.showRecords = false
          } else {
            this.searchList = [...this.searchList, ...data]
          }
        } else if (code === 9006) {
          if (pageNum === 1) {
            this.noData = true
            this.count = 0
            this.searchList = []
            this.showRecords = true
          }
          this.finished = true
        } else {
          this.$toast(msg)
        }
      }
    },

    /**
     * 排序
    */
    sortProduct () {
      this.sortChecked = this.sortChecked >= 2 ? 0 : ++this.sortChecked
      this.pageNum = 1
      this.searchList = []
      window.scrollTo(0, 0)
      this.searchInfo(this.sortChecked, this.pageNum)
    },

    /**
     * 滚动事件
    */
    scrollHandler (e) {
      this.scrollTop = e.target.scrollTop
    }
  },
  activated () {
    document.getElementById('searchPage').scrollTo(0, sessionStorage.getItem('scrollTop'))
  },
  deactivated () {
    if (this.$route.name === 'productDetails') {
      sessionStorage.setItem('scrollTop', this.scrollTop)
    }
  }
}
</script>

<style lang="less" scoped>
.search-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  font-size: @fz24;
  background-color: #f8f8f8;
  .auto;
  .search-page-wrapper {
    padding: 0.9rem 0 0.3rem;
  }
  .search-bar {
    position: fixed;
    top: 0rem;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 0.9rem;
    display: flex;
    align-items: center;
    z-index: 11;
    background-color: #fff;
    border-bottom: 0.5px solid #f8f8f8;
    box-sizing: border-box;
    input {
      width: 6rem;
      height: 0.6rem;
      border: 0.5px solid #ccc;
      vertical-align: top;
      border-radius: 30px;
      padding-left: 0.63rem;
      margin-left: 0.24rem;
      margin-right: 0.3rem;
      background: url("../assets/img/search.png") 0.14rem no-repeat;
      background-size: 0.3rem;
    }
    input::-webkit-search-cancel-button {
      -webkit-appearance: none;
    }
    input::-webkit-input-placeholder {
      color: #808080;
    }
    .cancel {
      font-size: 0.24rem;
      color: #404040;
    }
  }
  .search-container {
    .title {
      position: fixed;
      width: 100%;
      top: 0.9rem;
      border-bottom: 0.14rem solid #f8f8f8;
      background-color: #fff;
      z-index: 9;
      .title-wrapper {
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.34rem;
        border-bottom: 0.5px solid #ececec;
      }
      .price-sort {
        display: flex;
        align-items: center;
        height: 100%;
        .triangle {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-direction: column;
          .up-triangle,
          .down-triangle {
            margin-left: 0.1rem;
            border-width: 0.1rem;
            border-style: solid;
            border-color: #979797 transparent transparent transparent;
          }
          .up-triangle {
            transform: rotate(180deg);
          }
          .down-triangle {
            margin-top: 0.05rem;
            /*顺时针旋转90°*/
          }
        }
        .triangle a.checked {
          border-color: #ff2851 transparent transparent transparent;
        }
      }
      em {
        color: #ff2851;
      }
    }
    .search-list {
      padding: 0.8rem 0.2rem 0.3rem;
    }
  }
  .search-default {
    padding: 0.4rem 0.24rem;
    h2 {
      color: #404040;
      font-size: 0.24rem;
    }
    .list {
      display: flex;
      flex-wrap: wrap;
      margin: 0.4rem 0 0.54rem;
      li {
        margin-right: 0.3rem;
        margin-bottom: 0.2rem;
      }
      li:last-child {
        margin-right: 0;
      }
    }
    button {
      padding: 0.11rem 0.32rem;
      background-color: #eaeaea;
      border-radius: 30px;
    }
  }
  .no-data {
    width: 100%;
    height: 3.5rem;
    background: url("../assets/img/search.png") top 0.95rem center no-repeat;
    background-size: 0.6rem;
    font-size: 0.24rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      padding-top: 0.34rem;
    }
  }
}
</style>
